<template>
  <div id="notFound" class="notFound">
    <div>404</div>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// NotFound.vue?45fcbd21